import cityApi from './api';
import * as types from './actionTypes';

// Utils
import isomorphicCookies from '../../../utils/isomorphicCookies';

import { FETCH_USER_CITY_SUCCESS_BACKUP } from './actionTypes';

export const fetchCities = params => {
  return dispatch => {
    dispatch({ type: types.FETCH_CITIES_REQUEST });

    return cityApi
      .getCities(params)
      .then(data => {
        return dispatch({ type: types.FETCH_CITIES_SUCCESS, payload: data });
      })
      .catch(() => {
        return dispatch({ type: types.FETCH_CITIES_FAILURE });
      });
  };
};

export const fetchUserCity = req => {
  return dispatch => {
    dispatch({ type: types.FETCH_USER_CITY_REQUEST });

    const { locale, city_id, headers, ip } = req;
    // нужно для опрпделения текущего города по ip
    const newHeaders = { 'X-Forwarded-For': headers['x-real-ip'] || ip };
    const newParams = { lang: locale };

    // запрашиваем данные по городу из куки city_id, если кука не установлена и city_id = undefined
    // то город придет исходя из ip адреса в хедере запроса
    if (city_id) {
      newParams.city_id = city_id;
    }

    return cityApi
      .getUserCity(newParams, newHeaders)
      .then(data => {
        dispatch({ type: types.FETCH_USER_CITY_SUCCESS_BACKUP, payload: data[0] });
        return dispatch({ type: types.FETCH_USER_CITY_SUCCESS, payload: data[0] });
      })
      .catch(() => {
        return dispatch({ type: types.FETCH_USER_CITY_FAILURE });
      });
  };
};

export const setUserCity = cityId => {
  return dispatch => {
    dispatch({ type: types.SET_USER_CITY, payload: cityId });
  };
};

export const searchCities = query => {
  return dispatch => {
    dispatch({ type: types.SEARCH_CITIES, payload: query });
  };
};

export const selectUserCity = city => {
  return dispatch => {
    const { pathname, origin, search } = window.location;

    if (!city?.id) {
      return;
    }

    isomorphicCookies().set('city_id', city.id);
    isomorphicCookies().remove('delivery_alert_is_shown');
    isomorphicCookies().set('city_confirm', '1', { expires: 7 });

    // если у этого города есть супертег, то делаем урл с городом
    const oldPathname = pathname.split('/');
    oldPathname[1] = city._supertag;
    const newPathname = oldPathname.join('/');

    window.location.assign(`${origin}${newPathname}${search}`);
  };
};

export const setWaitOpenings = () => ({ type: types.SET_WAIT_OPENINGS_CITY });
